import { ThemeProvider } from "@emotion/react";
import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "./_common/enum/forms/fomTemplateType.enum";
import { UserLicenseTypeEnum } from "./_common/enum/forms/userLicenseType.enum";
import AuthRoute from "./_components/auth/auth-route";
import { accountService } from "./_services/accounts.service";
import { theme } from "./_styles/theme.styles";
import { FormIndex } from "./form/form-index";
import { FormManage } from "./form/form-manage";
import { FormPageManage } from "./form/form-pageManage";
import { FormResult } from "./form/form-result";
import { FormShoppingCart } from "./form/form-shoppingCart";
import { AccountIndex } from "./pages/account/account-index";
import { ContactForm } from "./pages/contact/contact-form";
import { DashboardIndex } from "./pages/dashboard/dashboard-index";
import { DiscountIndex } from "./pages/discount/discount-index";
import { EventIndex } from "./pages/event/event-index";
import { EventDocumentTemplateIndex } from "./pages/eventDocumentTemplate/eventDocumentTemplate-index";
import { FileUploadTypeIndex } from "./pages/fileUploadType/fileUploadType-index";
import { FormTemplateIndex } from "./pages/formTemplate/formTemplate-index";
import { FormTemplateSectionView } from "./pages/formTemplate/formTemplateSection.tsx/formTemplateSection-view";
import { LoginForgotPassword } from "./pages/login/login-forgotPassword";
import { LoginIndex } from "./pages/login/login-index";
import { LoginResetPassword } from "./pages/login/login-resetPassword";
import { LoginVerifyCode } from "./pages/login/login-verifyCode";
import { PaymentConfirmation } from "./pages/payment/payment-confirmation";
import { PaymentForm } from "./pages/payment/payment-form";
import { RacingClubIndex } from "./pages/racingClub/racingClub-index";
import { OfficialLicenseGradeIndex } from "./pages/officialLicenseGrade/officialLicenseGrade-index";
import { OfficialLicenseTypeIndex } from "./pages/officialLicenseType/officialLicenseType-index";
import { RacingLicenseIndex } from "./pages/racingLicenseGrade/racingLicenseGrade-index";
import { RacingLicenseTypeIndex } from "./pages/racingLicenseType/racingLicenseType-index";
import { ReportIndex } from "./pages/report/report-index";
import { UserCompetitionLicenseApplication } from "./pages/user/user-competitionLicenseApplication";
import { UserCompetitionLicenseApplicationCreate } from "./pages/user/user-competitionLicenseApplicationCreate";
import { UserIndex } from "./pages/user/user-index";
import { UserManage } from "./pages/user/user-manage";
import { UserProfilePage2 } from "./pages/user/user-profilePage2";
import { UserRegister } from "./pages/user/user-register";
import UserCartItemIndex from "./pages/userCartItem/userCartItems-index";
import { UserProfileCompetitionLicenseIndex } from "./pages/userProfile/userProfile-competitionLicenseIndex";
import { UserProfileEventList } from "./pages/userProfile/userProfile-eventList";
import { UserProfileEventView } from "./pages/userProfile/userProfile-eventView";
import { UserProfileFinesList } from "./pages/userProfile/userProfile-finesList";
import { UserProfileFineView } from "./pages/userProfile/userProfile-fineView";
import { UserProfileFormsList } from "./pages/userProfile/userProfile-formsList";
import { UserProfileGenericLicenseIndex } from "./pages/userProfile/userProfile-genericLicenseIndex";
import { UserProfileGenericQuestionnaireIndex } from "./pages/userProfile/userProfile-genericQuestionnaireIndex";
import { UserProfileInsuranceDatabaseList } from "./pages/userProfile/userProfile-insuranceDatabaseList";
import { UserProfileInsuranceList } from "./pages/userProfile/userProfile-insuranceList";
import { UserProfileLicenseView } from "./pages/userProfile/userProfile-licenseView";
import { UserProfileMyEventList } from "./pages/userProfile/userProfile-myEventList";
import { UserProfileOfficialLicenseIndex } from "./pages/userProfile/userProfile-officialLicenseIndex";
import { UserProfileUploadList } from "./pages/userProfile/userProfile-uploadList";
import { UserTransactionIndex } from "./pages/userTransaction/userTransaction-index";
import { AppScreen } from "./screens/app-screen";
import { AuthScreen } from "./screens/auth-screen";
import { EmailTemplateIndex } from "./_components/emailTemplate/emailTemplate-index";
import { EmailChecklistIndex } from "./_components/emailChecklist/emailChecklist-index";
import { UserProfileUploadManageDrawer } from "./pages/userProfile/userProfile-uploadManageDrawer";
import { UserCreditIndex } from "./pages/userCredit/userCredit-index";
import { UserProfileUserCreditsList } from "./pages/userProfile/userProfile-userCredits";
import { UserCreditManageDrawer } from "./pages/userCredit/userCredit-manageDrawer";
import { UserProfilePageOrganiser } from "./pages/user/user-profilePageOrganiser";
import { UserView } from "./pages/user/user-view";

function App() {

    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
    const { reload } = useParams<{ reload: string }>();

    useEffect(() => {
        // if(accountService.isAdmin !== true && accountService.isAdmin !== false) 
        // document.location.href = "/Login"

        setIsAdmin(accountService.isAdmin)
    }, [accountService.isAdmin]);

    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Routes>

                    <Route path="/login" element={<AuthScreen />}>

                        <Route path=":reload" element={<LoginIndex />} />
                        <Route path="" element={<LoginIndex />} />

                        <Route path="register" element={<UserRegister />} />
                        <Route path="verifycode/:email" element={<LoginVerifyCode />} />
                        <Route path="forgotpassword" element={<LoginForgotPassword />} />
                        <Route path="resetpassword/:code" element={<LoginResetPassword />} />
                    </Route>

                    {(!accountService.isAdmin && !accountService.isOrganiser) &&
                        <Route path="/" element={<AuthRoute element={<AppScreen />} />}>
                            <Route path="" element={<UserProfilePage2 />} >

                                <Route path="Info" element={<UserManage />} >
                                    <Route path="Licence/:token" element={<UserProfileLicenseView />} />
                                </Route>

                                <Route path="" element={<UserManage />} >
                                    <Route path="Licence/:token" element={<UserProfileLicenseView />} />
                                </Route>

                                <Route path="CompetitionLicenceApplication" element={<UserCompetitionLicenseApplication />} >
                                    <Route path="Create" element={<UserCompetitionLicenseApplicationCreate />} />
                                    <Route path="Edit/:formId" element={<FormManage />} />
                                </Route>

                                <Route path="UserEvents/*" element={<UserProfileMyEventList />} />
                                <Route path="Insurance/:type/*" element={<UserProfileInsuranceList />} />
                                <Route path="Media/*" element={<UserProfileGenericLicenseIndex formTemplateType={FormTemplateTypeEnum.Media} userLicenseType={UserLicenseTypeEnum.Media} />} />
                                <Route path="Questionnaire/:questionnaireName/*" element={<UserProfileGenericLicenseIndex formTemplateType={FormTemplateTypeEnum.Questionnaire} userLicenseType={UserLicenseTypeEnum.Questionnaire} />} />

                                <Route path="MinorEntrant/*" element={<UserProfileCompetitionLicenseIndex isMinor={true} />} />
                                <Route path="OneDayEvent/*" element={<UserProfileGenericLicenseIndex formTemplateType={FormTemplateTypeEnum.OneDayEvent} userLicenseType={UserLicenseTypeEnum.OneDayEvent} />} />

                                <Route path="Events" element={<UserProfileEventList />} />
                                <Route path="Events/View/:eventId" element={<UserProfileEventView />} />

                                <Route path="MotorLicences/*" element={<UserProfileCompetitionLicenseIndex isMinor={false} />} >
                                </Route>

                                <Route path="Official/*" element={<UserProfileOfficialLicenseIndex />} />
                                <Route path="OfficialLicences/*" element={<UserProfileOfficialLicenseIndex />} />
                                <Route path="/UserCredits/*" element={<UserCreditIndex />} />

                                <Route path="Fines" element={<UserProfileFinesList />}>
                                    <Route path=":fineId" element={<UserProfileFineView />} />
                                </Route>

                                <Route path="Forms" element={<UserProfileFormsList />} />
                                <Route path="Forms/:formId" element={<FormManage />} />
                                <Route path="Forms/:formId/ShoppingCart" element={<FormShoppingCart />} />

                                <Route path="Uploads/:formId/ShoppingCart" element={<FormShoppingCart />} />

                                {/* <Route path="Uploads" element={<UserProfileUploadList />} /> */}
                                <Route path="Uploads/*" element={<UserProfileUploadList />} />

                                <Route path="FormResult/:formId" element={<FormResult />} />
                                <Route path="UserCart/:userCartId" element={<UserCartItemIndex />} />
                                <Route path="UserCart/:userCartId/PaymentForm" element={<PaymentForm />} />


                                <Route path="PaymentConfirmation" element={<PaymentConfirmation />} />
                            </Route>
                        </Route>
                    }

                    {(accountService.isAdmin === true) &&
                        <Route path="/" element={<AuthRoute element={<AppScreen />} />}>

                            <Route path="/Licence/:token" element={<UserProfilePage2 />} >
                                <Route path="" element={<UserManage />} >
                                    <Route path="" element={<UserProfileLicenseView />} />
                                </Route>
                            </Route>

                            <Route path="/Dashboard" element={<DashboardIndex />} />
                            <Route path="/Users" element={<UserIndex />} />

                            <Route path="/Users/:userId/*" element={<UserProfilePage2 />} >

                                <Route path="" element={<UserManage />} >
                                    <Route path="Licence/:token" element={<UserProfileLicenseView />} />
                                    {/* <Route path="UserCredit" element={<UserCreditManageDrawer isOpen={true} itemId={null} />} /> */}
                                </Route>

                                <Route path="CompetitionLicenceApplication" element={<UserCompetitionLicenseApplication />} >
                                    <Route path="Create" element={<UserCompetitionLicenseApplicationCreate />} />
                                    <Route path="Edit/:formId" element={<FormManage />} />
                                </Route>

                                <Route path="Uploads" element={<UserProfileUploadList />} />

                                <Route path="UserEvents/*" element={<UserProfileMyEventList />} />
                                <Route path="Insurance/:type/*" element={<UserProfileInsuranceList />} />
                                <Route path="Media/*" element={<UserProfileGenericLicenseIndex formTemplateType={FormTemplateTypeEnum.Media} userLicenseType={UserLicenseTypeEnum.Media} />} />
                                <Route path="Database/*" element={<UserProfileInsuranceDatabaseList />} />

                                <Route path="MinorEntrant/*" element={<UserProfileCompetitionLicenseIndex isMinor={true} />} />
                                <Route path="OneDayEvent/*" element={<UserProfileGenericLicenseIndex formTemplateType={FormTemplateTypeEnum.OneDayEvent} userLicenseType={UserLicenseTypeEnum.OneDayEvent} />} />
                                <Route path="Questionnaire/:questionnaireName/*" element={<UserProfileGenericQuestionnaireIndex />} />

                                <Route path="Events" element={<UserProfileEventList />} />
                                <Route path="UserCredits" element={<UserProfileUserCreditsList />} />
                                <Route path="Events/View/:eventId" element={<UserProfileEventView />} />

                                <Route path="MotorLicences/*" element={<UserProfileCompetitionLicenseIndex isMinor={false} />} />

                                <Route path="Uploads/*" element={<UserProfileUploadList />} />
                                {/* <Route path=":licenseId" element={<UserProfileLicenseView />} /> */}
                                {/* </Route> */}

                                <Route path="OfficialLicences/*" element={<UserProfileOfficialLicenseIndex />} />

                                <Route path="Fines" element={<UserProfileFinesList />}>
                                    <Route path=":fineId" element={<UserProfileFineView />} />
                                </Route>

                                <Route path="Forms" element={<UserProfileFormsList />} />
                                <Route path="Forms/:formId" element={<FormManage />} />
                                <Route path="Forms/:formId/ShoppingCart" element={<FormShoppingCart />} />
                                <Route path="FormResult/:formId" element={<FormResult />} />

                                <Route path="UserCart/:userCartId" element={<UserCartItemIndex />} />
                                <Route path="UserCart/:userCartId/PaymentForm" element={<PaymentForm />} />
                                <Route path="PaymentConfirmation" element={<PaymentConfirmation />} />
                            </Route>

                            <Route path="/UserCart/:userCartId/PaymentForm" element={<PaymentForm />} />
                            <Route path="/UserCart/:userCartId" element={<UserCartItemIndex />} />

                            <Route path="/PaymentForm" element={<PaymentForm />} />
                            <Route path="/PaymentConfirmation" element={<PaymentConfirmation />} />
                            <Route path="/UserTransactions" element={<UserTransactionIndex />} />
                            <Route path="/ContactForm" element={<ContactForm />} />

                            <Route path="/EventDocumentTemplate/*" element={<EventDocumentTemplateIndex />} />

                            <Route path="/FormTemplates/*" element={<FormTemplateIndex />} />
                            <Route path="/Forms/:formId" element={<FormPageManage />} />
                            <Route path="/Forms" element={<FormIndex />} />
                            <Route path="/FormTemplateSections/:formTemplateSectionId/*" element={<FormTemplateSectionView />} />

                            <Route path="/RacingLicenseTypes" element={<RacingLicenseTypeIndex />} />
                            <Route path="/RacingClubs" element={<RacingClubIndex />} />
                            <Route path="/Discounts" element={<DiscountIndex />} />
                            <Route path="/EmailTemplates" element={<EmailTemplateIndex />} />
                            <Route path="/EmailChecklist" element={<EmailChecklistIndex />} />
                            <Route path="/RacingLicenseGrades" element={<RacingLicenseIndex />} />
                            <Route path="/OfficialLicenseTypes" element={<OfficialLicenseTypeIndex />} />
                            <Route path="/OfficialLicenseGrades" element={<OfficialLicenseGradeIndex />} />


                            <Route path="/Events/*" element={<EventIndex />} />
                            <Route path="/UserCredits/*" element={<UserCreditIndex />} />

                            <Route path="/Reports" element={<ReportIndex />} />
                            <Route path="/FileUploadTypes" element={<FileUploadTypeIndex />} />
                            <Route path="/Register" element={<UserRegister />} />


                            <Route path="/Accounts" element={<AccountIndex />} />
                        </Route>
                    }

                    {(accountService.isOrganiser === true) &&
                        <Route path="/" element={<AuthRoute element={<AppScreen />} />}>

                            <Route path="/Users" element={<UserIndex />} />
                            <Route path="/Users/:userId/*" element={<UserProfilePageOrganiser />} >

                                <Route path="" element={<UserView />} >
                                    {/* <Route path="Licence/:token" element={<UserProfileLicenseView />} /> */}
                                    {/* <Route path="UserCredit" element={<UserCreditManageDrawer isOpen={true} itemId={null} />} /> */}
                                </Route>
                            </Route>

                            <Route path="" element={<UserProfilePage2 />} >
                                <Route path="Info" element={<UserManage />} >
                                    <Route path="Licence/:token" element={<UserProfileLicenseView />} />
                                </Route>

                                <Route path="" element={<UserManage />} >
                                    <Route path="Licence/:token" element={<UserProfileLicenseView />} />
                                </Route>

                                <Route path="CompetitionLicenceApplication" element={<UserCompetitionLicenseApplication />} >
                                    <Route path="Create" element={<UserCompetitionLicenseApplicationCreate />} />
                                    <Route path="Edit/:formId" element={<FormManage />} />
                                </Route>



                                <Route path="UserEvents/*" element={<UserProfileMyEventList />} />
                                <Route path="Insurance/:type/*" element={<UserProfileInsuranceList />} />
                                <Route path="Media/*" element={<UserProfileGenericLicenseIndex formTemplateType={FormTemplateTypeEnum.Media} userLicenseType={UserLicenseTypeEnum.Media} />} />
                                <Route path="Questionnaire/:questionnaireName/*" element={<UserProfileGenericLicenseIndex formTemplateType={FormTemplateTypeEnum.Questionnaire} userLicenseType={UserLicenseTypeEnum.Questionnaire} />} />

                                <Route path="MinorEntrant/*" element={<UserProfileCompetitionLicenseIndex isMinor={true} />} />
                                <Route path="OneDayEvent/*" element={<UserProfileGenericLicenseIndex formTemplateType={FormTemplateTypeEnum.OneDayEvent} userLicenseType={UserLicenseTypeEnum.OneDayEvent} />} />

                                <Route path="Events" element={<UserProfileEventList />} />
                                <Route path="Events/View/:eventId" element={<UserProfileEventView />} />

                                <Route path="MotorLicences/*" element={<UserProfileCompetitionLicenseIndex isMinor={false} />} >
                                </Route>

                                <Route path="Official/*" element={<UserProfileOfficialLicenseIndex />} />
                                <Route path="OfficialLicences/*" element={<UserProfileOfficialLicenseIndex />} />
                                <Route path="/UserCredits/*" element={<UserCreditIndex />} />

                                <Route path="Fines" element={<UserProfileFinesList />}>
                                    <Route path=":fineId" element={<UserProfileFineView />} />
                                </Route>

                                <Route path="Forms" element={<UserProfileFormsList />} />
                                <Route path="Forms/:formId" element={<FormManage />} />
                                <Route path="Forms/:formId/ShoppingCart" element={<FormShoppingCart />} />

                                <Route path="Uploads/:formId/ShoppingCart" element={<FormShoppingCart />} />

                                {/* <Route path="Uploads" element={<UserProfileUploadList />} /> */}
                                <Route path="Uploads/*" element={<UserProfileUploadList />} />

                                <Route path="FormResult/:formId" element={<FormResult />} />
                                <Route path="UserCart/:userCartId" element={<UserCartItemIndex />} />
                                <Route path="UserCart/:userCartId/PaymentForm" element={<PaymentForm />} />


                                <Route path="PaymentConfirmation" element={<PaymentConfirmation />} />
                            </Route>
                        </Route>
                    }



                    {(accountService.isAdmin !== false && accountService.isAdmin !== true) &&
                        <Route path="/*" element={<Navigate to="/Login" replace />} />
                    }

                    {/* < Route path="/user" element={<UserScreen />}>
                        <Route path="" element={<UserLogin />} />
                        <Route path="register" element={<UserRegister />} />
                        <Route path="verifycode/:email" element={<UserVerifyCode />} />
                        <Route path="forgotpassword" element={<UserForgotPassword />} />
                        <Route path="resetpassword/:code" element={<UserResetPassword />} />
                        <Route path="profile" element={<UserProfilePage />} />
                    </Route> */}
                </Routes>
            </BrowserRouter>
        </ThemeProvider >
    );
}

export default App;

